/**
 * Режим работы без бэкенда.
 *
 * Включается переменной REACT_APP_NO_BACKEND: страница модели считается
 * полностью на клиенте, поэтому запросы к /api ожидаемо не проходят —
 * ругаться на это всплывающими сообщениями не нужно.
 */
export const NO_BACKEND = process.env.REACT_APP_NO_BACKEND === 'true'

/** Показывает ошибку сети только тогда, когда сервер вообще ожидается. */
export const notifyNetworkError = (message, text) => {
    if (NO_BACKEND) {
        console.info('[нет бэкенда]', text)
        return
    }
    message.error(text)
}
